(ns vire.adserver.view.colors)

(def main-background "#f9fafc")

(def grey-border "#D9DEE4")

(def storrito-color "#ff404c")

(def storrito-color-1 "#012C40")

(def storrito-color-2 "#1CA5B8")

(def storrito-color-3 "#DAEBF2")

(def storrito-color-4 "#0f83b7")

(def storrito-free "#6c757d")

(def storrito-basic "#f3a32b")

(def storrito-standard "#82bf6e")

(def storrito-professional storrito-color)

(def storrito-dark "#012c40")

(def storrito-green "#58bc3c")

(def storrito-blue "#2598D6")

(def disabled "#888888")

(def active-text "#2f2f2f")

(def passive-text "#9fa9a7")

#_(def background-color "#f4f3f6")

(def background-color-transparent "rgba(255,255,255,1)")

(def background-warning "#ffaa00")

(def background-warning-transparent "rgba(255,170,0,0.7)")

(def background-info-transparent "rgba(37, 152, 214,0.7)")

(def background-danger "#c40024")

(def background-danger-light "#ffabba")

(def background-danger-transparent "rgba(196,0,36,0.7)")

(def background-success "#2E7D32")

(def background-success-transparent "rgba(46,125,50,0.7)")

(def storrito-grey "#dcdcdc")

(def text-color "#4c4c4c")

(def error-text-color "#a94442")

(def error-background-color "#ffaba9")

(def success-text-color "#2E7D32")

(def highlight-color "#d4e9ff")

(def burrito-color "#f2d115")

(def storrito-border {:border (str "1px solid " storrito-grey)
                      :border-radius "10px"})

(def facebook-color
  "#3b5998")